import {TextProps} from '@chakra-ui/react';
import React, {memo} from 'react';
import {UiText} from '~/components/elements/index';

interface Props extends TextProps {}

export const UiTitle = memo(({...rest}: Props) => <UiText fontFamily="SecularOne" fontWeight="bold" {...rest} />);
